import style from './ContentPageTitle.module.scss';

export type ContentPageTitleType = {
  title: string;
};
export const ContentPageTitle = ({ title }: ContentPageTitleType): JSX.Element => {
  return <h2 className={style.container}>{title}</h2>;
};
